module.exports = __webpack_public_path__ + "static/media/10.d1a0a97a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/10.jpg
// module id = 787
// module chunks = 0